import React from 'react';
import { ShoppingBasket as Basketball } from 'lucide-react';

export default function BasketballCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('basketball-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-orange-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Basketball className="w-12 h-12 text-orange-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Name Your Basketball Team?
        </h2>
        <p className="text-xl text-orange-100 mb-8">
          Join thousands of basketball teams who've found their perfect name with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-orange-600 text-lg px-8 py-4 rounded-lg hover:bg-orange-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Create Your Team Name Now!
        </button>
        <p className="mt-6 text-sm text-orange-200">
          Perfect for streetball, college, and professional teams
        </p>
      </div>
    </section>
  );
}